import PropTypes from 'prop-types';

export const  AIThinking = ({ maxHeight}) => {
    const thinkingImage = `<svg viewBox="-2000 -1000 4000 2000" style="fill: none; stroke: #ddd; stroke-linecap: round; stroke-width: 8%; max-height: ${maxHeight}; width: auto; height: auto;">
<style>@keyframes a { to { stroke-dashoffset: 0px } }</style>
<path id="inf" d="M354-354A500 500 0 1 1 354 354L-354-354A500 500 0 1 0-354 354z"></path>
<use xlink:href="#inf" stroke-dasharray="1570 5143" stroke-dashoffset="6713px" style="stroke: #00aeef; animation: a 2s linear infinite"></use>
</svg>`

return <div style={{}} dangerouslySetInnerHTML={{ __html: thinkingImage }}></div>

}

AIThinking.propTypes = {
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}